export default "__VITE_ASSET__RdCQkHVb__"